// About.js
import { useEffect, useState } from 'react';
import { Button, Col, Container, Nav, Row, Tab, Table } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { getUser } from '../../controllers/user';
import { useAuth } from '../../components/auth/AuthProvider';
import PerfilMatrimonioForm from '../../components/perfil/PerfilMatrimonioForm';
import PerfilMamaForm from '../../components/perfil/PerfilMamaForm';
import PerfilAsesorForm from '../../components/perfil/PerfilAsesorForm';
import Loading from '../../components/loading/Loading';
import DireccionForm from '../../components/perfil/DireccionForm';
import PerfilApostoladoForm from '../../components/perfil/PerfilApostoladoForm';
import PerfilCuentaForm from '../../components/perfil/PerfilCuenta';
import RegistroMembresiaManual from '../../components/perfil/RegistroManualMembresia';
import { getOrg } from '../../controllers/org';
import ErrorAlert from '../../components/errors/ErrorAlert';
import PerfilPermisosForm from '../../components/perfil/PerfilPermisos';

function User() {
  const params = useParams();
  const { token } = useAuth();
  const [org, setOrg] = useState();
  const [ user, setUser ] = useState();
  const [ membresiaIdx, setMembresiaIdx ] = useState(null);
  const [ editarMembresia, setEditarMembresia ] = useState(false);
  const [ registroMembresiaManual, setRegistroMembresiaManual ] = useState(false);
  const [ reload, setReload ] = useState(0);
  const [errorCode, setErrorCode] = useState(); 
  const navigate = useNavigate();
  let membresias = [];

  useEffect(() => {
    if (user) {
      document.title = `FAMA - User`;
    }
  }, [user]);

  useEffect(() => {
    loadUser();
    loadOrg();
  }, [reload]);
  async function loadUser() {
    try {
      const data = await getUser(token, params.memberId);
      setUser(data);
    }
    catch (e) {
      console.log(e);
      if (!isNaN(e.status)) {
        setErrorCode(e.status);
      }
    }
  }

  async function loadOrg(){
    let o = await getOrg();
    setOrg(o);
  }

  function renderPerfil() {
    console.log('user', user);
    let perfil = {
      nombre1: user.profile.first_name_1,
      nombre2: user.profile.first_name_2,
      apellido: user.profile.last_name,
      telefono1: user.profile.phone_1,
      telefono2: user.profile.phone_2
    }
    switch (user.profile.profile_type_id) {
      case 1: 
        perfil.tipo = 'matrimonio';
        return <PerfilMatrimonioForm updateProfile perfil={perfil} userId={user.user_id} />;
      case 2: 
        perfil.tipo = 'mama';
        return <PerfilMamaForm updateProfile perfil={perfil} userId={user.user_id} />;
      case 3: 
        perfil.tipo = 'asesor';
        return <PerfilAsesorForm updateProfile perfil={perfil} userId={user.user_id} />;
    }
  }

  function toggleEditarMembresia(ev) {
    let idx = ev.target.getAttribute('data-idx');
    console.log(membresias[idx]);
    setMembresiaIdx(idx);
    setEditarMembresia(!editarMembresia);
  }

  function toggleRegistrarPago(ev) {
    let idx = ev.target.getAttribute('data-idx');
    setMembresiaIdx(idx);
    setRegistroMembresiaManual(!registroMembresiaManual);
  }

  function reloadMembresias(type) {
    if (type === 'registro-manual') {
      setRegistroMembresiaManual(false);
    }
    else if (type === 'editar-membresia') {
      setEditarMembresia(false);
    }
    setReload(reload + 1);
  }

  function renderMembresias() {
    let ciclos = [];
    let memberships = [];
    membresias = [];
    user.memberships.forEach((m, idx) => {
      ciclos.push(m.ciclo);
      let role;
      let coordinadorEquipo = false;
      let apostoladoNacional = false;
      let apostoladoComunidad = false;
      m.membership_roles.forEach(r => {
        switch (r.role.level) {
          case 1:
          case 2: 
          case 3:
            apostoladoNacional = true;
            role = r.role_id;
            break;
          
          case 4:
            apostoladoComunidad = true;
            role = r.role_id;
            break;
          
          case 5:
            const regex = /coordinador.+equipo de formaci/;
            console.log('regex', r.role.label.toLowerCase(), r.role.label.toLowerCase().match(regex));
            if (r.role.label.toLowerCase().match(regex)) {
              coordinadorEquipo = true;
            }
            role = r.role_id;
            break;
        }
      })
      const membresia = {
        comunidad: m.comunidad_id,
        diocesis: m.diocesis_id,
        region: m.region_id,
        role: role,
        coordinadorEquipo: coordinadorEquipo,
        apostoladoComunidad: apostoladoComunidad,
        apostoladoNacional: apostoladoNacional,
        etapa: m.etapa_id,
        profileType: m.profile_type_id,
        ciclo: m.ciclo
      };
      membresias.push(membresia);

      // memberships.push(<PerfilApostoladoForm
      //   membresia={{profileType: m.profile_type_id}}
      //   apostolado={membresia}
      // />);

      let status = 'No Pagado';
      let acciones;

      if (m.order) {
        status = 'Pagado';
        acciones = <Button variant='secondary' data-idx={idx} onClick={toggleEditarMembresia}>Editar</Button>;
      }
      else if (m.profile_type_id === 3) {
        status = 'Gratis';
        acciones = <Button variant='secondary' data-idx={idx} onClick={toggleEditarMembresia}>Editar</Button>;
      }
      else if (m.acciones === 'Registrar pago') {
        acciones = <>
          <Button variant='secondary' data-idx={idx} onClick={toggleEditarMembresia} className='mb-2'>Editar</Button>
          <Button variant='secondary' data-idx={idx} onClick={toggleRegistrarPago}>Registrar pago</Button>
        </>;
      }

      memberships.push(<tr  key={`membership-${params.memberId}-${m.ciclo}`}>
        <td >{m.ciclo}</td>
        <td >{m.region.label}</td>
        <td >{m.diocesis.label}</td>
        <td >{m.comunidad.label}</td>
        <td >{coordinadorEquipo ? 'Sí' : 'No'}</td>
        <td >{m.membership_roles[0]?.role.label}</td>
        <td >{m.etapa?.title || ''}</td>
        <td className={status === 'No Pagado' ? 'bg-warning' : ''}>{status}</td>
        <td >{acciones}</td>
      </tr>)
    });

    return <Table striped hover>
      <thead><tr>
        <td>Ciclo</td>
        <td>Región</td>
        <td>Diócesis</td>
        <td>Comunidad</td>
        <td>Coordinador de Equipo</td>
        <td>Apostolado</td>
        <td>Nivel</td>
        <td>Estatus</td>
        <td>Acciones</td>
      </tr></thead>
      <tbody>
        {memberships}
      </tbody>
    </Table>
  }

  if (errorCode) {
    return <Container className='pt-5 pb-5'>
      <ErrorAlert code={errorCode} />
    </Container>;
  }
  if (!user) {
    return <Loading />
  }

  return (
    <Container className='p-5'>
      <h1>Editar miembro</h1>
      <Tab.Container id="user-tabs" defaultActiveKey="perfil">
        <Row>
          <Col sm={3}>
            <Nav variant="pills" className="flex-column">
              <Nav.Item><Nav.Link eventKey="perfil">Perfil</Nav.Link></Nav.Item>
              <Nav.Item><Nav.Link eventKey="direccion">Dirección</Nav.Link></Nav.Item>
              <Nav.Item><Nav.Link eventKey="apostolado">Apostolados</Nav.Link></Nav.Item>
              <Nav.Item><Nav.Link eventKey="permisos">Permisos</Nav.Link></Nav.Item>
              <Nav.Item><Nav.Link eventKey="cuenta">Cuenta</Nav.Link></Nav.Item>
            </Nav>
          </Col>
          <Col sm={9}>
            <Tab.Content>
              <Tab.Pane eventKey="perfil">
                <Container>
                  <h2>Perfil</h2>
                  {renderPerfil()}
                </Container>
              </Tab.Pane>
              <Tab.Pane eventKey="direccion">
                <Container>
                  <h2>Dirección</h2>
                  <DireccionForm updateProfile
                    userId={user.user_id}
                    direccion={{
                      direccion: user.profile.address_1,
                      direccion2: user.profile.address_2,
                      ciudad: user.profile.city,
                      estado: user.profile.state,
                      zipCode: user.profile.zip_code
                    }} />
                </Container>
              </Tab.Pane>
              <Tab.Pane eventKey="apostolado">
                <Container>
                  <h2>Membresías / Apostolados</h2>
                  <div className='table-wrapper'>
                    {renderMembresias()}
                  </div>

                  {membresiaIdx != null && editarMembresia && !registroMembresiaManual &&
                    <Col md={6}><PerfilApostoladoForm updateProfile
                      userId={user.user_id}
                      membresia={{profileType: membresias[membresiaIdx].profileType}}
                      apostolado={membresias[membresiaIdx]}
                      completedMembershipUpdate={reloadMembresias}
                      org={org}
                    /></Col>
                  }
                  {membresiaIdx != null && !editarMembresia && registroMembresiaManual &&
                    <Col md={6}>
                      <RegistroMembresiaManual membership={{
                        user_id: user.user_id,
                        profile_type_id: membresias[membresiaIdx].profileType,
                        region_id: membresias[membresiaIdx].region,
                        diocesis_id: membresias[membresiaIdx].diocesis,
                        comunidad_id: membresias[membresiaIdx].comunidad,
                        etapa_id: membresias[membresiaIdx].etapa,
                        role: membresias[membresiaIdx].role,
                        coordinadorEquipo: membresias[membresiaIdx].coordinadorEquipo,
                        ciclo: membresias[membresiaIdx].ciclo
                      }}
                      completedMembershipUpdate={reloadMembresias} />
                    </Col>
                  }
                </Container>
              </Tab.Pane>
              <Tab.Pane eventKey="cuenta">
                <Container>
                  <h2>Cuenta</h2>
                  <PerfilCuentaForm updateProfile userId={user.user_id} email={user.email} />
                </Container>
              </Tab.Pane>
              <Tab.Pane eventKey="permisos">
                <Container>
                  <h2>Permisos</h2>
                  <PerfilPermisosForm
                    updateProfile
                    userId={user.user_id}
                    consents={user.user_consent_maps}
                  />
                </Container>
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
      <Row>
          <Button variant="info" onClick={() => navigate(-1)} className='cancelar'>
            Regresar
          </Button>
      </Row>
    </Container>
  );
}

export default User;
